import { Loader2 } from 'lucide-react';
import { PropsWithChildren, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { useSubscriptionStorefrontAccess } from '../hooks/useSubscriptionManagementAvailability';
import { trackEvent } from '../integrations/analytics/client';

export const SubscriptionAccessGuard = ({
  children,
}: PropsWithChildren) => {
  const location = useLocation();
  const { isSubscriptionManagementAvailable, loading } =
    useSubscriptionStorefrontAccess();

  useEffect(() => {
    if (loading || isSubscriptionManagementAvailable) {
      return;
    }

    trackEvent("ios_subscription_route_blocked", {
      attemptedPath: location.pathname,
      redirectTarget: ROUTES.settings,
      trigger: "subscription_access_guard",
    });
  }, [isSubscriptionManagementAvailable, loading, location.pathname]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!isSubscriptionManagementAvailable) {
    return <Navigate to={ROUTES.settings} replace />;
  }

  return <>{children}</>;
};
